<template>
  <div>
    <b-field
      :label="$translate('tec') | capitalize"
      :type="{ 'is-danger': errors.has('tec') }"
      :message="errors.first('tec')"
      horizontal
    >
      <b-input v-model="order.tec" v-validate="'required'" name="tec" disabled />
    </b-field>

    <b-field
      :label="$translate('id_mercury') | capitalize"
      :type="{ 'is-danger': errors.has('id_mercury') }"
      :message="errors.first('id_mercury')"
      horizontal
    >
      <b-input
        v-model="order.id_mercury"
        v-validate="{
          required: isMercuryEditable(),
        }"
        name="id_mercury"
        :disabled="disabledbool || isMercuryEditable() == false"
      />
    </b-field>
    <b-field
      v-show="userInfo.type != 'C'"
      :label="$translate('statusOrder') | capitalize"
      :type="{ 'is-danger': errors.has('statusOrder') }"
      :message="errors.first('statusOrder')"
      horizontal
    >
      <b-select v-model="order.statusOrder" v-validate="'required'" name="statusOrder">
        <option
          v-for="type in status"
          :key="type"
          :value="type"
          :disabled="isTransitionDoable(currentStatus, type, order) == false"
        >
          {{ $translate(type) | capitalize }}
        </option>
      </b-select>
    </b-field>
    <b-field :label="$translate('primaryCode') | capitalize" horizontal>
      <b-field :type="{ 'is-danger': errors.has('primaryCode') }" :message="errors.first('primaryCode')">
        <b-input
          v-model="order.primaryCode"
          v-validate="'required|unique|notnull'"
          name="primaryCode"
          :disabled="disabledbool"
        />
      </b-field>
      <b-button
        type="button"
        class="button is-primary"
        :disabled="disabledbool"
        icon-right="auto-fix"
        @click="primaryCodeCreation()"
      >
        {{ $translate('generate_primaryCode') | capitalize }}
      </b-button>
    </b-field>
    <b-field horizontal v-if="!isSimplified">
      <template v-if="order.secondaryCodeBool">
        <b-button
          :disabled="disabledbool"
          class="is-danger is-inverted"
          @click="
            order.secondaryCodeBool = false
            $forceUpdate()
          "
        >
          {{ $translate('remove_secondary_code') }}<b-icon icon="minus-circle" size="is-small" />
        </b-button>
      </template>
      <template v-else>
        <b-button
          class="is-primary is-inverted"
          :disabled="disabledbool"
          @click="
            order.secondaryCodeBool = true
            $forceUpdate()
          "
        >
          {{ $translate('add_secondary_code') }}
          <b-icon icon="plus-circle" size="is-small" />
        </b-button>
      </template>
    </b-field>
    <b-field
      v-if="order.secondaryCodeBool"
      :type="{ 'is-danger': errors.has('secondaryCode') }"
      :message="errors.first('secondaryCode')"
      horizontal
    >
      <template slot="label">
        {{ $translate('secondaryCode') | capitalize }}
        <b-tooltip type="is-dark" :label="$translate('help_secondaryCode')" multilined>
          <b-icon size="is-small" icon="help-circle-outline" />
        </b-tooltip>
      </template>
      <b-input v-model="order.secondaryCode" name="secondaryCode" :disabled="disabledbool" />
    </b-field>

    <b-field
      v-if="precPairOptions.length > 0 && !isSimplified && config.orderHasPrecPair"
      :type="{ 'is-danger': errors.has('prec_pair') }"
      :message="errors.first('prec_pair')"
      horizontal
    >
      <template slot="label">
        {{ $translate('prec_pair') | capitalize }}
        <b-tooltip type="is-dark" :label="$translate('help_prec_pair') | capitalize" multilined>
          <b-icon size="is-small" icon="help-circle-outline" />
        </b-tooltip>
      </template>
      <b-select v-model="order.prec_pair" name="prec_pair" :disabled="disabledbool">
        <option :value="null">
          {{ $translate('Noone') | capitalize }}
        </option>
        <option v-for="pre in precPairOptions" :key="pre" :value="pre">
          {{ pre }}
        </option>
      </b-select>
    </b-field>

    <b-field
      v-if="precOrderOptions.length > 0 && !isSimplified && config.orderHasPrecPair"
      :type="{ 'is-danger': errors.has('prec_order') }"
      :message="errors.first('prec_order')"
      horizontal
    >
      <template slot="label">
        {{ $translate('prec_order') | capitalize }}
        <b-tooltip type="is-dark" :label="$translate('help_prec_order') | capitalize" multilined>
          <b-icon size="is-small" icon="help-circle-outline" />
        </b-tooltip>
      </template>
      <b-select v-model="order.prec_order" name="prec_order" :disabled="disabledbool">
        <option :value="null">
          {{ $translate('Noone') | capitalize }}
        </option>
        <option v-for="pre in precOrderOptions" :key="pre" :value="pre">
          {{ pre }}
        </option>
      </b-select>
    </b-field>

    <b-field :type="{ 'is-danger': errors.has('ASLprotocol') }" :message="errors.first('ASLprotocol')" horizontal>
      <template slot="label">
        {{ $translate('ASLprotocol') | capitalize }}
      </template>
      <b-input v-model="order.ASLprotocol" name="ASLprotocol" :disabled="disabledbool || language != 'it'" />
    </b-field>

    <b-field v-if="config.orderHasPairSelector" :label="$translate('pairSelected') | capitalize" horizontal>
      <b-select
        v-model="order.pair"
        v-validate="'required'"
        :disabled="disabledbool"
        name="pairSelected"
        @input="onPairChange"
      >
        <option :key="0" value="both">{{ $translate('pairBoth') }}</option>
        <option :key="1" value="right">{{ $translate('pairRight') }}</option>
        <option :key="2" value="left">{{ $translate('pairLeft') }}</option>
      </b-select>
    </b-field>

    <b-field
      v-if="config.orderHasShoeCatalogType"
      :label="$translate('shoeType') | capitalize"
      :type="{ 'is-danger': errors.has('shoeType') }"
      :message="errors.first('shoeType')"
      class="correction-error-field-body"
      horizontal
    >
      <b-select
        v-model="order.shoeType"
        v-validate="{ required: config.orderHasShoeCatalogType }"
        name="shoeType"
        :placeholder="$translate('placeholder_select')"
        :disabled="disabledbool"
        @input="
          ResetModel()
          $forceUpdate()
        "
      >
        <option v-for="type in $availableShoeType" :key="type" :value="type">
          {{ $translate(type) | capitalize }}
        </option>
      </b-select>
      <b-field
        :label="$translate('catalogType') | capitalize"
        :type="{ 'is-danger': errors.has('catalogType') }"
        :message="errors.first('catalogType')"
        horizontal
        expanded
      >
        <b-select
          v-model="order.catalogType"
          v-validate="{ required: config.orderHasShoeCatalogType }"
          name="catalogType"
          :placeholder="$translate('placeholder_select')"
          :disabled="disabledbool"
          @input="
            ResetModel()
            $forceUpdate()
          "
        >
          <option v-for="type in $availableSexType" :key="type" :value="type">
            {{ $translate(type) | capitalize }}
          </option>
        </b-select>
      </b-field>
    </b-field>
    <b-field v-if="config.orderHasSeason" :label="$translate('seasontags') | capitalize" horizontal expanded>
      <b-select
        v-model="order.seasontag"
        name="seasonFilter"
        :placeholder="$translate('placeholder_select')"
        :disabled="disabledbool"
        @input="$emit('onChangeSeasonFilter', order.seasontag)"
      >
        <option :value="null"></option>
        <option v-for="item in $seasontag" :key="item" :value="item">
          {{ $translate(item) | capitalize }}
        </option>
      </b-select>
    </b-field>
    <template v-if="config.orderHasShape">
      <b-field v-if="order.catalogType && order.shoeType" :label="$translate('shape') | capitalize" horizontal expanded>
        <b-select
          v-model="shape"
          name="shapeFilter"
          :placeholder="$translate('placeholder_select')"
          @input="() => $emit('onChangeShapeFilter', shape)"
        >
          <option :value="null"></option>
          <option v-for="shape in filteredShapes" :key="shape.id" :value="shape.id">
            {{ shape.commercial_name + ' ' + shape.fit_code }}
          </option>
        </b-select>
      </b-field>
      <b-field v-else>
        <p>{{ $translate('select_catalogType_shoeType') | capitalize }}</p>
      </b-field>
    </template>
    <b-field
      v-if="config.hasSecondaryPrev"
      :label="$translate('secondary_prevention') | capitalize"
      horizontal
      expanded
    >
      <b-switch name="secondaryPrev" v-model="secondaryPrev" @input="handleSecondaryPrev"> </b-switch>
    </b-field>

    <b-field
      v-if="config.orderHasDigitalArchive"
      :label="$translate('digital_archive') | capitalize"
      horizontal
      :type="{ 'is-danger': errors.has('digitalArchive') }"
      :message="errors.first('digitalArchive')"
    >
      <b-checkbox v-model="order.hasDigitalArchive" v-validate="{ required: secondaryPrev }" />
    </b-field>

    <template v-if="config.orderHasPatologies">
      <b-field horizontal>
        <div v-show="pathologiesbool" class="columns">
          <div class="column">
            <b-field :label="$translate('label_pato_sx')">
              <b-select v-model="order.pathologiesLeft" multiple native-size="5" :disabled="disabledbool">
                <option v-for="pathology in pathologies" :key="pathology.name" :value="pathology.name">
                  {{ $translate(pathology.name) }}
                </option>
              </b-select>
            </b-field>
            <p class="content">
              {{ $translate('multiple_select_info') }}
            </p>
          </div>
          <div class="column">
            <b-field :label="$translate('label_pato_dx')">
              <b-select v-model="order.pathologiesRight" multiple native-size="5" :disabled="disabledbool">
                <option v-for="pathology in pathologies" :key="pathology.name" :value="pathology.name">
                  {{ $translate(pathology.name) }}
                </option>
              </b-select>
            </b-field>
            <p class="content">
              {{ $translate('multiple_select_info') }}
            </p>
          </div>
        </div>
      </b-field>
    </template>
  </div>
</template>

<script>
import orderTools from '@/helpers/mixins/orderTools'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import { capitalize } from '@vue/shared'
import { modelFits, modelModular, modelTailored } from '@/helpers/mixins/modelTools'

export default {
  name: 'OrderGeneralInfo',
  mixins: [permissionMixin, orderTools],
  props: [
    'order',
    'patient',
    'pathologiesbool',
    'status',
    'disabledbool',
    'currentStatus',
    'isSaveDisabled',
    'language',
    'isSimplified',
    'config',
    'shapeFilter',
    'hasSecondaryPrev',
  ],
  data() {
    return {
      pathologies: [],
      shapes: [],
      shape: '',
      secondaryPrev: null,
    }
  },
  computed: {
    filteredShapes() {
      return this.shapes.filter(
        shape => shape.catalogType.includes(this.order.catalogType) && shape.type === this.order.shoeType
      )
    },
    precPairOptions() {
      if (this.order.module === 'insole') {
        return this.patient.prec_pair_shoes || []
      }
      return this.patient.prec_pair || []
    },
    precOrderOptions() {
      if (this.order.module === 'insole') {
        return this.patient.prec_order || []
      }
      return this.patient.prec_pair || []
    },
  },
  watch: {
    shapeFilter(val) {
      if (val !== this.shape) {
        this.shape = val
      }
    },
    hasSecondaryPrev(val) {
      if (val !== this.secondaryPrev) {
        this.secondaryPrev = val
      }
    },
  },
  inject: ['$validator'],
  mounted() {
    //console.log(this.isSimplified)
    if (this.config.orderHasPatologies) {
      const pathologies = []
      this.$db
        .collection('pathologies')
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let pathology = doc.data()
            pathology.id = doc.id
            pathologies.push(pathology)
          })
          this.pathologies = [...pathologies]
        })
    }
    if (this.config.orderHasShape) {
      const shapes = []
      this.$db
        .collection(this.config.shapes)
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let shape = doc.data()
            shape.id = doc.id
            shapes.push(shape)
          })
          this.shapes = [...shapes]
        })
    }
  },
  methods: {
    capitalize,
    onPairChange() {
      if (this.order.pair !== 'both') {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('message_reset_measurements'),
          cancelText: this.$translate('undo_reset_measurements'),
          confirmText: this.$translate('confirm_reset_measurements'),
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert',
          onConfirm: () => this.enableOneSide(),
          onCancel: () => (this.order.pair = 'both'),
        })
      } else {
        this.enableOneSide()
      }
    },
    enableOneSide() {
      this.order.isDunaInsoleDisabledDx = this.order.pair === 'left'
      this.order.isDunaInsoleDisabledSx = this.order.pair === 'right'
      this.$emit('onPairSwitched', this.order.pair)
      this.$forceUpdate()
    },
    handleSecondaryPrev() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('message_reset_model'),
        cancelText: this.$translate('undo_reset_model'),
        confirmText: this.$translate('confirm_reset_model'),
        type: 'is-danger',
        hasIcon: true,
        icon: 'alert',
        onConfirm: () => {
          this.order.typecontr_sx = null
          this.order.typecontr_dx = null
          this.order.tipocontr_sx = null
          this.order.tipocontr_dx = null
          this.order.tipocontr_var_sx = null
          this.order.tipocontr_var_dx = null
          this.resetOrderMod()
          this.$emit('onChangeSecondaryPrev', this.secondaryPrev)
          this.$forceUpdate()
        },
        onCancel: () => {
          this.secondaryPrev = !this.secondaryPrev
        },
      })
    },
    resetOrderMod() {
      let tempMod
      switch (this.order.module) {
        case 'tailored':
          tempMod = new modelTailored().returnObject()
          break
        case 'fits':
          tempMod = new modelFits().returnObject()
          break
        case 'modular':
          tempMod = new modelModular().returnObject()
          break
        default:
          tempMod = new modelTailored().returnObject()
      }
      this.order.mod = tempMod
    },
    ResetModel() {
      if (this.order.shoeType == 'high') {
        if (
          this.order.typecontr_dx == 'calc' ||
          this.order.typecontr_dx == 'short' ||
          this.order.typecontr_dx == 'pro_med' ||
          this.order.typecontr_dx == 'pro_lat'
        ) {
          this.order.typecontr_dx = null
        }
        if (
          this.order.typecontr_sx == 'calc' ||
          this.order.typecontr_sx == 'short' ||
          this.order.typecontr_sx == 'pro_med' ||
          this.order.typecontr_sx == 'pro_lat'
        ) {
          this.order.typecontr_sx = null
        }
      } else {
        if (
          this.order.typecontr_dx == 'semi_bi' ||
          this.order.typecontr_dx == 'medial' ||
          this.order.typecontr_dx == 'sidal' ||
          this.order.typecontr_dx == 'rig_bi' ||
          this.order.typecontr_dx == 'peronoic'
        ) {
          this.order.typecontr_dx = null
        }
        if (
          this.order.typecontr_sx == 'semi_bi' ||
          this.order.typecontr_sx == 'medial' ||
          this.order.typecontr_sx == 'sidal' ||
          this.order.typecontr_sx == 'rig_bi' ||
          this.order.typecontr_sx == 'peronoic'
        ) {
          this.order.typecontr_sx = null
        }
      }
      let tempMod
      switch (this.order.module) {
        case 'tailored':
          tempMod = new modelTailored().returnObject()
          break
        case 'fits':
          tempMod = new modelFits().returnObject()
          break
        case 'modular':
          tempMod = new modelModular().returnObject()
          break
        default:
          tempMod = new modelTailored().returnObject()
      }
      if (this.order.mod.name) {
        this.$buefy.dialog.confirm({
          title: this.$translate('attention'),
          message: this.$translate('message_reset_model'),
          cancelText: this.$translate('undo_reset_model'),
          confirmText: this.$translate('confirm_reset_model'),
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert',
          onConfirm: () => (this.order.mod = tempMod),
        })
      }
    },
    async primaryCodeCreation() {
      this.$emit('update:isSaveDisabled', true)
      let mercurio_id = '-'
      await this.$db
        .collection('companies')
        .doc(this.order.companyId)
        .get()
        .then(async com => {
          mercurio_id = com.data().mercurio_id
          if (com.data().orders) {
            this.patient.progressivenumber = com.data().orders.length + 1
          } else {
            this.patient.progressivenumber = 1
          }
        })

      let today = new Date()
      let day = String(today.getUTCDate()).padStart(2, '0')
      let month = String(today.getUTCMonth() + 1).padStart(2, '0')

      this.order.primaryCode =
        day +
        month +
        today.getUTCFullYear() +
        '-' +
        mercurio_id +
        '-' +
        ('0000' + this.patient.progressivenumber).substr(-4, 4)

      this.$emit('update:isSaveDisabled', false)
      this.$forceUpdate()
    },
  },
}
</script>
